// extracted by mini-css-extract-plugin
module.exports = {"main":"classes-module__main___2GqBv","main_content":"classes-module__main_content___3Mi7X"};